import React, { FC } from 'react';
import { Button } from '@clearcover/atlas';

import styles from './styles.module.css';

type BusinessUseModalContentProps = {
  closeModal: () => void;
};

export const BusinessUseModalContent: FC<BusinessUseModalContentProps> = ({
  closeModal,
}) => (
  <div className={styles.businessUseModal}>
    <h2>1. Acceptable Business Use</h2>
    <p>
      Vehicles owned or leased by the applicant and used in the applicant's
      business or occupation, providing the usage is deemed acceptable per the
      following guidelines:
    </p>
    <ul>
      <li>
        The vehicle is not used to travel to more than three work sites during
        the workday.
      </li>
      <li>
        Vehicles used by sales representatives, realtors and home health
        professionals.
      </li>
      <li>
        Vehicles used by professionals whose occupations include frequent travel
        to hospitals, clinics, courthouses, job sites or client homes. Examples
        are doctors, attorneys, architects, engineers and clergy.
      </li>
      <li>
        Only the named insured and family members operate the vehicle. (Vehicles
        operated by an employee or co-worker are not acceptable.)
      </li>
      <li>
        Goods transported by the vehicle or a trailer attached to the vehicle
        must be used by the operator at the job site in performance of the
        operator's craft or trade. The goods must not be transported for
        delivery or sale of the product or good.
      </li>
    </ul>
    <h2>2. Unacceptable Business Use</h2>
    <ul>
      <li>
        Any wholesale or retail delivery such as food, newspapers, magazines, or
        mail.
      </li>
      <li>Any vehicle used to transport clients, employees or co-workers.</li>
      <li>
        Vehicles with permanently installed equipment such as hoists, lifts, air
        compressors, pumps, utility or side mount tool boxes, generators,
        spraying, welding or other service equipment.
      </li>
      <li>Vehicles owned or leased by a corporation or business.</li>
      <li>Vehicles used in transporting passengers for a fee.</li>
      <li>Vehicles operated by employees or co-workers.</li>
      <li>Vehicles used to carry explosives, chemicals, and flammables.</li>
      <li>Any vehicle with a commercial license plate.</li>
      <li>Traveling to more than 3 job sites per day.</li>
      <li>More than one business use vehicle per household per policy.</li>
      <li>
        Any vehicle used to tow a trailer carrying equipment/supplies used
        regularly for pickup and delivery for the sole purpose of distribution,
        resale, or delivery. Any goods or property picked up or delivered must
        be used by the operator at the job site in performance of the operator's
        craft or trade.
      </li>
      <li>
        Participation in a transportation network company or other ride sharing
        service or transporting passengers for a fee.
      </li>
    </ul>
    <p>A surcharge will apply to acceptable business use.</p>
    <div className={styles.businessUseModalButtonContainer}>
      <Button variant="primary" size="sm" onClick={closeModal}>
        Continue
      </Button>
    </div>
  </div>
);
